import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ca-header',
    templateUrl: './ca-header.component.html',
    styleUrls: ['./ca-header.component.scss'],
    standalone: false
})
export class CaHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
